import { ParkingContainer } from '../../containers/advancedFilters/ParkingContainer';
import { IFilter } from '../../types/advancedFilters';

export const parking: IFilter = {
  component: ParkingContainer,
};
